
export default {
  name: 'LayoutAuth',

  props: {
    title: {
      type: String,
      default: ''
    },

    sideImage: {
      type: String,
      default: require('~/assets/images/backgrounds/auth-bg.jpg')
    },

    hasFixedHeight: {
      type: Boolean,
      default: true
    }
  },

  mounted() {
    this.$store.dispatch('device/changeStatusBarColorWhite')
  },

  destroyed() {
    this.$store.dispatch('device/changeStatusBarColorPrimary')
  }
}
